import {useAuth} from '@apps-common/auth-react';
import AppsDropdown from '@apps-common/ui-components/NavBar/AppsDropdown.jsx';
import NavBar from '@apps-common/ui-components/NavBar/NavBar.jsx';
import React, {useCallback} from 'react';

import HelpMenu from './help-menu.jsx';
import {reset as resetAnalytics, trackEvent} from '@explorer/analytics';
import {clearState} from '@explorer/blobz/util';
import {DEPLOY_ENV} from '@explorer/config.js';

const TopNavBar = () => {
  const auth = useAuth();

  const logout = useCallback(() => {
    trackEvent('Logout Button clicked');

    resetAnalytics();
    clearState();

    auth.signOut();
  }, [auth]);

  return (
    <NavBar
      title={<AppsDropdown appKey="explorer" environment={DEPLOY_ENV} />}
      user={auth.user?.claims}
      secondary={
        <>
          <HelpMenu />
        </>
      }
      logout={logout}
      sx={{zIndex: 'modal'}}
      environment={DEPLOY_ENV}
      className="pl-mode-dark"
    />
  );
};

export default TopNavBar;
